import { InMemoryCacheConfig } from "@apollo/client";

const parseDate = (time: string) => new Date(parseInt(time));

export const CACHE_CONFIG: InMemoryCacheConfig = {
  typePolicies: {
    Employee: {
      merge: true,
      fields: {
        startDate: {
          read: parseDate,
        },
        endDate: {
          read: parseDate,
        },
        createdAt: {
          read: parseDate,
        },
        updatedAt: {
          read: parseDate,
        },
      },
    },
  },
};
